export default {"src":"/_next/static/media/wheel-position-en.6846232c.svg","height":1064,"width":1063,"blurWidth":0,"blurHeight":0};